import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Cliente } from '../model/cliente';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})


export class ClienteapiService {

  user;
  pass;
  pessoasUrl;
  auth;
  dominioAux;
  pubUrl;
  constructor(private http: HttpClient,
              public global: GlobalService) {
  this.user = this.global.user;
  this.pass = this.global.pass;
  this.auth = btoa(this.user + ':' + this.pass);

  console.log('Console log do Construtor Pura ' + this.global.dominio);
  this.dominioAux = this.global.dominio;
  console.log('Console log do Construtor Dentro da var ' + this.dominioAux);
  this.pessoasUrl = this.dominioAux + '/backend/api/v2/cliente';
  this.pubUrl = this.dominioAux + '/backend/api/v1/pub/recuperar';
  console.log('Console log do Construtor PessoasUrl ' + this.pessoasUrl);
              }

  listarTodas(): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pessoasUrl}/todos`, {headers})
      .toPromise();
  }


  getById(codigo: any): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pessoasUrl}/mostrar/${codigo}`, {headers})
      .toPromise();
  }


  excluir(codigo: any): Promise<void> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.delete(`${this.pessoasUrl}/deletar/${codigo}`, {headers})
      .toPromise()
      .then(() => null);
  }


  GetByNome(text: string): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pessoasUrl}/pesquisarNome/${text}`, {headers})
      .toPromise();
  }

  recuperarSenha(email): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pubUrl}/recuperarSenha/${email}`, {headers})
      .toPromise();
  }



  save(cliente: Cliente) {
    if (cliente.id) {
      return this.atualizar(cliente);
    } else {
      return this.adicionar(cliente);
    }
  }


  adicionar(cliente: Cliente): Promise<Cliente> {
     console.log(cliente);
     let headers = new HttpHeaders();
     headers = headers.set('Authorization', 'Basic ' + this.auth);
     const body = JSON.stringify(cliente);
     return this.http.post<Cliente>(`${this.pessoasUrl}/inserir`, body, {headers})
  .toPromise();

  }




  atualizar(cliente: Cliente): Promise<Cliente> {
    console.log(cliente);
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    // tslint:disable-next-line: max-line-length
    const body = JSON.stringify(cliente);
    return this.http.put(`${this.pessoasUrl}/editar`, body, {headers})
      .toPromise()
      .then(response => {
        const pessoaAlterada = response as Cliente;
        return pessoaAlterada;
      });
  }


  verificaLogin(user, pass): Promise<any> {
    const auth = btoa(user + ':' + pass);
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + auth);
    return this.http.get(`${this.pessoasUrl}/validarUsuario`, {headers})
      .toPromise();
  }



  verificaLoginWeb(user, pass): Promise<any> {
    const auth = btoa(user + ':' + pass);
    console.log(this.global.dominio);
    console.log(this.pessoasUrl);
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + auth);
    return this.http.get(`${this.pessoasUrl}/validarUsuarioWeb/${user}/${pass}`, {headers})
      .toPromise();
  }


  getByDoc(user, pass, doc: any): Promise<any> {
    const auth = btoa(user + ':' + pass);
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + auth);
    return this.http.get(`${this.pessoasUrl}/getByDocumento/${doc}`, {headers})
      .toPromise();
  }

}

